'use strict';
/*eslint no-unused-vars: 0, no-extra-parens: 0*/
import React from 'react';
import { render, ReactDOM } from 'react-dom';
import { Link } from 'react-router-dom';

import classNames from 'classnames';

import helpers from '../lib/helpers';

import ContentList from '../components/ContentList';
import SideBar from '../components/SideBar';
import InfoBox from '../components/InfoBox';
import RelatedInfoLinks from '../components/RelatedInfoLinks';
import SvgIcon from '../components/SvgIcon';
import SafeLink from '../components/SafeLink';

import services from '../lib/services';

if(window) {
  require('scrollto.js');
}

const headerTitleTag = window ? document.querySelector('head>title') : null,
      siteName = 'SIRA Claims Pathway';


export default class MyReactComponent extends React.Component {
  constructor(props) {
    super(props);


    let queryInitialPage;
    if(window) {
      let searchQuery = this.props.history.location.search;
      //if there's an item id in the query then let's go there
      if(searchQuery.match(/^\?page=\d+/)) {
        queryInitialPage = searchQuery.match(/\d+/)[0];
        console.log(`INITIAL PAGE ID ${queryInitialPage}`);
      }      
    }


    this.state = {
      noAnimation: false,
      loadingLeft: false,
      loadingRight: false,
      currentPage: matrixData.initialPage || queryInitialPage || matrixData.topLevelPage,
    };
  }

  componentDidMount() {
    //listen for browser back/forward
    this.props.history.listen((location, action) => {
      let searchQuery = location.search;
      if(searchQuery) {
        if(searchQuery.match(/^\?page=\d+/)) {
          let newPageId = searchQuery.match(/\d+/)[0],
              isGoingBack = matrixData.pages[this.state.currentPage].parent == newPageId;
          console.log(`GO TO PAGE ID ${newPageId}`);
          this.goToItem({
            id: newPageId,
            isGoingBack
          });
        }
      } else {
        //no search query - go to first question
        this.goToItem({
          isGoingBack: true,
          id: matrixData.topLevelPage
        });
      }
      // this.setInnerContentHeight();
    });
    // this.setInnerContentHeight();
  }

  goToUrl(url) {
    this.props.history.push(url);
  }

  goToItem(ops) {
    let page = matrixData.pages[ops.id],
        headTitle = page.title + (page.titleAdditional?' '+page.titleAdditional:''),
        isTopLevel = ops.id == matrixData.topLevelPage;

    if(window && typeof headerTitleTag != 'undefined'){
      headerTitleTag.innerHTML = `${headTitle} - ${siteName}`;
    }

    //add loading class
    //fade out
    this.setState({[ops.isGoingBack?'loadingRight':'loadingLeft']: true});
    setTimeout(()=>{
      /*
      once faded out we need to immediately move the content to 
      the opposite side with no animation
      */
      this.setState({
        noAnimation: true,
        loadingLeft: ops.isGoingBack?true:false,
        loadingRight: ops.isGoingBack?false:true,
      });

      //then immediately switch animation back on
      setTimeout(()=>{
        this.showContent(ops);
      },10);
    },500);
  }

  getContent(ops, callback) {
    let item = matrixData.pages[ops.id],
        isAnswerContentItem = item.childrenItems?false:true;

    //if it's an answer content and content hasn't yet been populated, fire off service to get contents
    if(isAnswerContentItem && !item.content) {
      services.getPageContents(ops.id).then(resp=>{
        item.content = resp;
        callback();
      }).catch(resp=>{
        callback();
        console.log(`Something went wrong. The page contents couldn't be fetched. Please try refreshing your browser.\n\n${resp.statusText} (${resp.status})`);
      });
    } else {
      // if it's a question or content is already populated then just go straight there
      callback();
    }

  }

  showContent(ops) {
    //if there's no children items, this is a content item
    this.getContent(ops, ()=>{
      let isDesktop = helpers.isDesktop(),
          isTopLevel = ops.id == matrixData.topLevelPage;

      //check if frontend (not server side)
      // if(window) {
      //   setTimeout(()=>{
      //     let animOps = {horizontal: false}
      //     if(isDesktop){
      //       //if desktop, we want to go a bit higher to see the nice blue bg
      //       // animOps.offsetY = -50;
      //       animOps.offsetY = -192;
      //     } else {
      //       if(!isTopLevel) {
      //         //if mobile and it's not the home page, we want to go a bit higher to see the back button
      //         // animOps.offsetY = -25;
      //         animOps.offsetY = -106;
      //       }
      //     }

      //     // this.setInnerContentHeight();
 
      //     window.scrollToElement(document.querySelector('.s-inside__wrapper'), animOps);
      //   }, 500);
      // } 

      this.setState({
        currentPage: ops.id,
        noAnimation: false,
        [ops.isGoingBack?'loadingLeft':'loadingRight']: false
      });
    });
  }

  //if the height of sidebar is greater than main content, set min height to main content = sidebar height + 30px
  setInnerContentHeight() {
    let isDesktop = helpers.isDesktop();
    if(this.refs.sidebar.scrollHeight > this.refs.innerContainer.scrollHeight && isDesktop) {
      this.refs.innerContainer.style.minHeight = this.refs.sidebar.scrollHeight + 30 + 'px';
      //console.log('innercontainer resized');
    } else {
      this.refs.innerContainer.style.minHeight = '';
    }
  }

  render() {
    let page = matrixData.pages[this.state.currentPage],
        isTopLevel = this.state.currentPage == matrixData.topLevelPage,
        content = page.content,
        prevButtonUrl = matrixData.topLevelPage!=page.parent?helpers.getUrlTitle(page.parent):matrixData.urlHome,
        wrapperClasses = classNames({
          'o-content': true,
          'is-first-level': isTopLevel,
          'loading-left': this.state.loadingLeft,
          'loading-right': this.state.loadingRight,
          'no-animation': this.state.noAnimation,
          'has-sidebar': page.sideBarBoxes && page.sideBarBoxes.length > 0,
          'is-sidebar-loading': this.state.loadingLeft || this.state.loadingRight,
          'is-results-page': page.childrenItems ? false : true,
        });


    return (
      <div ref="container" className={wrapperClasses}>
        <div ref="content" className="o-content__wrapper">
          <div ref="innerContainer" className="o-content__inner t-bg--white">
            <div className="v-spinner">
              <div className="v-spinner--double-bounce1"></div>
              <div className="v-spinner--double-bounce2"></div>
            </div>
            {page.sideBarBoxes && page.sideBarBoxes.length > 0 && <InfoBox boxes={page.sideBarBoxes} />}
            <div className="nsw-in-page-alert nsw-in-page-alert--info nsw-in-page-alert--compact">
                <span
                  className="material-icons nsw-material-icons nsw-in-page-alert__icon"
                  tabIndex="-1"
                  aria-hidden="true"
                >
                  info
                </span>
                <div className="nsw-in-page-alert__content">
                    <p>No personal information is taken when interacting with the tool and your responses will not be saved by SIRA. However, you may download a copy of the results as a PDF. This will allow you to then save that PDF to your device, or print a hard copy, for your records.</p>
                </div>
              </div>
            <div className="s-inside__wrapper">
              <div className="s-inside__heading">
                <h2 className="s-inside__heading__title">{page.title} {page.titleAdditional}</h2>
              </div>
              <div className="s-inside__body">

                {page.subTitle &&
                  <h4>{page.subTitle}</h4>
                }

                <ContentList 
                  page={page} 
                  goToUrl={this.goToUrl.bind(this)}
                />

                {page.childrenItems && 
                  <div className="p-decision__wrapper">
                    {/* <div className="p-decision__inner"> */}
                      {/* <ul className="c-tab__list"> */}
                      <div className="nsw-grid">
                        {page.childrenItems.map(item=>
                          <div key={`item_${item.id}`} className="nsw-col">
                            <div className="nsw-card nsw-card--headline">
                                <SafeLink
                                  className="nsw-card__content"
                                  key={`item-${item.id}`}
                                  to={helpers.getUrlTitle(item.id)}
                                >
                                  <span class="p-decision__link nsw-card__title">
                                    {item.title} 
                                    {item.titleAdditional != '' && 
                                      <strong>&nbsp;{item.titleAdditional}</strong>
                                    }
                                  </span>
                                </SafeLink>
                            </div>
                          </div>
                        )}
                      {/* </ul> */}
                      {/* </div> */}
                    </div>
                  </div>
                }

              </div>
              <div className="s-inside__ctrl">
                <div className="button__wrapper">
                  <SafeLink
                    to={matrixData.urlHome}
                    className="nsw-button nsw-button--dark"
                  >
                    Start tool again
                  </SafeLink>
                  {!page.childrenItems && 
                  <button
                    onClick={() => window.print()}
                    className="nsw-button nsw-button--dark"
                  >
                    Save as PDF
                  </button>
                  }
                </div>
                <SafeLink 
                  to={prevButtonUrl}
                  className="c-btn s-inside__prev"
                >
                  <span className="s-inside__ctrl__icon">
                  <span className="material-icons nsw-material-icons" focusable="false" aria-hidden="true">arrow_back</span>
                  </span>
                  Previous page
                </SafeLink>
                
              </div>
            </div>
          </div>

          <RelatedInfoLinks 
            heading={matrixData.relatedInfoLinksHeading}
            links={matrixData.relatedInfoLinks} 
          />

        </div>
      </div>
    );
  }
}